import {
  FETCH_REFILLER_PERMISSION,
  RESET_REFILLER_PERMISSION,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const refillerPermissionListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFILLER_PERMISSION:
      return { data: action.payload };
    case RESET_REFILLER_PERMISSION:
      return initialState;
    default:
      return state;
  }
};

export default refillerPermissionListReducer;
